// Internal modules
import { STATE_NAME } from '@/lib/logger';

const TRANSITION_NAME = {
  prepareDcc: 'prepare_currency_conversion',
  processDccSelection: 'process_currency_conversion_selection',
};

export const PREPARE_CURRENCY_CONVERSION_PAYLOAD = conversionData => {
  const payload = {
    is_conversion_needed: true,
    state: STATE_NAME.billing,
    transition_name: TRANSITION_NAME.prepareDcc,
  };

  if (!conversionData?.canChangeConversionType) {
    return {
      ...payload,
      conversion_reason: 'restricted_card_type',
      conversion_selection: conversionData ? 'PAYPAL' : 'VENDOR',
      is_conversion_shown: 0,
    };
  }

  // 'PAYPAL' is hard coded as the `conversion_selection` because it is
  // always the default selection when we first show the conversion options
  return {
    ...payload,
    conversion_reason: 'user_selected',
    conversion_selection: 'PAYPAL',
    is_conversion_shown: 1,
  };
};

export const PROCESS_CURRENCY_CONVERSION_SELECTION = selection => ({
  conversion_selection: selection,
  state_name: STATE_NAME.billing,
  transition_name: TRANSITION_NAME.processDccSelection,
});
